// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"f6a3e8dc","637":"ec314feb","898":"89fc9000","989":"a62fb966"}[chunkId] + ".chunk.css";
};